// extracted by mini-css-extract-plugin
module.exports = {"cont":"LayoutMobileSidebar_cont__1qVzv","title":"LayoutMobileSidebar_title__Wojw3","menu":"LayoutMobileSidebar_menu__ZNjlt"};